export default "__VITE_ASSET__BbQsPqIx__"